import AxiosClient from "../../../services/axios.services";

class PlanIndividualServices {
  getPlanIndividual = (params) =>
    AxiosClient.get(
      "/api/app/cursos_x_colaborador_x_plan/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  savePlanCursos = (data) =>
    AxiosClient.post(
      "/api/app/carrera_plan_cursos/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  savePlanCompetencias = (data) =>
    AxiosClient.post(
      "/api/app/carrera_plan_competencia/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editPlanCursos = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_plan_cursos/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editPlanCompetencias = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_plan_competencia/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deletePlanCursos = (id) =>
    AxiosClient.delete(
      `/api/app/carrera_plan_cursos/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  deletePlanCompetencias = (id) =>
    AxiosClient.delete(
      `/api/app/carrera_plan_competencia/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new PlanIndividualServices();
